import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './pageSection.module.css'

const PageSection = ({
  children,
  borderTop,
  darkBackground,
  spaceBottom,
  sectionId
}: {
  children: any
  borderTop?: boolean
  darkBackground?: boolean
  spaceBottom?: boolean
  sectionId?: string
}) => {
  const sectionClassName = classnames(styles.pageSection, {
    [styles.borderTop]: borderTop,
    [styles.darkBackground]: darkBackground,
    [styles.spaceBottom]: spaceBottom
  })
  return (
    <section id={sectionId} className={sectionClassName}>
      <div className={styles.gridContainer}>{children}</div>
    </section>
  )
}

export default PageSection
